import * as actionTypes from "../action-types";

const initialState = {
    //! Partner
    partnerData: [],
    affiliatesData: [],
    partnerByIdData: null,

    //* Customer
    customerByPartnerIdData: [],
    affiliatesByPartnerIdData: [],
    customersByAffiliateIdData: [],

    //! Partner Report Wallet
    partnerReportWalletData: []
};

const adminReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        //! Partner
        case actionTypes.SET_PARTNERS:
            return { ...state, partnerData: payload };
        case actionTypes.SET_AFFILIATES:
            return { ...state, affiliatesData: payload };

        case actionTypes.SET_PARTNER_BY_ID:
            return { ...state, partnerByIdData: payload };

        //* Customer
        case actionTypes.SET_CUSTOMER_BY_PARTNERID:
            return { ...state, customerByPartnerIdData: payload };
        case actionTypes.SET_AFFILIATE_BY_PARTNERID:
            return { ...state, affiliatesByPartnerIdData: payload };
        case actionTypes.SET_CUSTOMER_BY_AFFILIATEID:
            return { ...state, customersByAffiliateIdData: payload };

        //! Partner Report Wallet
        case actionTypes.SET_PARTNER_REPORT_WALLETS:
            return { ...state, partnerReportWalletData: payload };

        default:
            return state;
    }
};

export default adminReducer;